<template>
  <div class="_404 page">
    <img
      :src="imgError"
      alt=""
    />
    <div class="page-bd">
      <p class="_404-label">您访问了一个不存在的页面</p>
      <p class="_404-label-secondary">请核实您的访问地址</p>
    </div>

    <!-- 版权 -->
    <!-- <c-version
      :language="$t('language')"
      :slogan="$t('globle.slogan')"
    /> -->
    <!-- 版权 -->
    <PCopyright v-show="false"></PCopyright>
  </div>
</template>

<script>
import PCopyright from '@c/PCopyright'
export default {
  components: {
    PCopyright
  },
  data() {
    return {
      imgError: require("@a/img/default/404.png")
    };
  },
  mounted() { },
  methods: {}
};
</script>

<style lang="less" scoped>
._404 {
  height: 100vh;
  background: #fff;

  img {
    width: 100%;
  }

  ._404-label {
    font-size: 24px;
    font-weight: 700;
    color: #78909c;
    text-align: center;
    letter-spacing: 1px;
  }

  ._404-label-secondary {
    font-size: 20px;
    color: #78909c;
    text-align: center;
    letter-spacing: 1px;
    margin-top: 15px;
  }

  ._404-action {
    margin-top: 50px;
    padding: 0px 20%;
    ._404-action-button {
      font-size: 16px;
      background: #78909c;
      color: #fff;
      box-shadow: none !important;
      display: block;
      height: 44px;
      width: 100%;
      border: none !important;

      &:active {
        background: #637781;
      }
    }
  }
}
</style>
